import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const PauseCircleGlyph = /*#__PURE__*/createElement("g", {
  xmlns: "http://www.w3.org/2000/svg",
  strokeWidth: "0.5px",
  style: {
    transform: 'scale(4) translate(-2.5%, -2%)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M11.9999 5.14279C15.7714 5.14279 18.8571 8.2285 18.8571 11.9999C18.8571 15.7714 15.7714 18.8571 11.9999 18.8571C8.2285 18.8571 5.14279 15.7714 5.14279 11.9999C5.14279 8.2285 8.2285 5.14279 11.9999 5.14279ZM11.9999 4.28564C7.74279 4.28564 4.28564 7.74279 4.28564 11.9999C4.28564 16.2571 7.74279 19.7142 11.9999 19.7142C16.2571 19.7142 19.7142 16.2571 19.7142 11.9999C19.7142 7.74279 16.2571 4.28564 11.9999 4.28564Z"
}), /*#__PURE__*/createElement("rect", {
  x: "13",
  y: "8.7998",
  width: "1",
  height: "6.45",
  rx: "0.5"
}), /*#__PURE__*/createElement("rect", {
  x: "10",
  y: "8.7998",
  width: "1",
  height: "6.45",
  rx: "0.5"
}));
const PauseCircle = createSvg({
  name: 'pauseCircle',
  path: PauseCircleGlyph,
  viewBox: '0 0 24 24'
});

export default PauseCircle;
export { PauseCircleGlyph };
